import React, { useState } from 'react';
import './MediaLibrary.scss';

export interface MediaImage {
  url: string;
  alt: string;
}

interface MediaLibraryProps {
  images: MediaImage[];
  onSelect: (img: MediaImage) => void;
  onUpload: (file: File) => void;
  onClose: () => void;
}

const MediaLibrary: React.FC<MediaLibraryProps> = ({ images, onSelect, onUpload, onClose }) => {
  const [selected, setSelected] = useState<number | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    if (file) onUpload(file);
  };

  return (
    <div className="media-library-modal">
      <div className="media-library-content">
        <div className="media-library-header">
          <span>Media Library</span>
          <button className="media-library-close" onClick={onClose}>×</button>
        </div>
        <div className="media-library-upload">
          <input type="file" accept="image/*" onChange={handleFileChange} />
        </div>
        <div className="media-library-grid">
          {images.map((img, idx) => (
            <div
              key={img.url + idx}
              className={`media-library-thumb${selected === idx ? ' selected' : ''}`}
              onClick={() => setSelected(idx)}
            >
              <img src={img.url} alt={img.alt} />
            </div>
          ))}
        </div>
        <div className="media-library-actions">
          <button
            className="media-library-btn"
            disabled={selected === null}
            onClick={() => selected !== null && onSelect(images[selected])}
          >
            Select
          </button>
        </div>
      </div>
    </div>
  );
};

export default MediaLibrary;

